/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type LangInput = "de" | "en" | "es" | "fr" | "it";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingsBreadcrumbs_aggregatesListings$ref: FragmentReference;
declare export opaque type AggregatesListingsBreadcrumbs_aggregatesListings$fragmentType: AggregatesListingsBreadcrumbs_aggregatesListings$ref;
export type AggregatesListingsBreadcrumbs_aggregatesListings = {|
  +filters: {|
    +places: ?$ReadOnlyArray<{|
      +breadcrumbs: $ReadOnlyArray<{|
        +slug: string,
        +lang: LangInput,
        +label: string,
        +canonicalPlace: ?{|
          +slug: string
        |},
      |}>
    |}>
  |},
  +$refType: AggregatesListingsBreadcrumbs_aggregatesListings$ref,
|};
export type AggregatesListingsBreadcrumbs_aggregatesListings$data = AggregatesListingsBreadcrumbs_aggregatesListings;
export type AggregatesListingsBreadcrumbs_aggregatesListings$key = {
  +$data?: AggregatesListingsBreadcrumbs_aggregatesListings$data,
  +$fragmentRefs: AggregatesListingsBreadcrumbs_aggregatesListings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingsBreadcrumbs_aggregatesListings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatesListingFilters",
      "kind": "LinkedField",
      "name": "filters",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Place",
          "kind": "LinkedField",
          "name": "places",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Place",
              "kind": "LinkedField",
              "name": "breadcrumbs",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lang",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Place",
                  "kind": "LinkedField",
                  "name": "canonicalPlace",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AggregatesListingConnectionConnection",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c0aa44d682948147dc125c3896dd188c';

export default node;
